import Swiper from './../imports/import-swiper';
export default ()=>{
  const container = document.querySelector('.lesson__slider');

  container? runSlider(): false;

  function runSlider(){
    const wellnesLessonSlider = new Swiper(container, {
      wrapperClass: 'lesson__slider-wrapper',
      slideClass: 'lesson__slide',
      allowTouchMove: true,
      loop: true,
      speed: 600,
      spaceBetween: 50,
      disableOnInteraction: false,
      waitForTransition: false,
      autoplay: {
        delay: 10000
      },
      slidesPerView: 1,
      pagination:{
        el: '.lesson__pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span></span></span>';
        }
      }
    });
  }
}
